module.exports = __webpack_public_path__ + "static/media/computer vision.ab2a57f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/subjects/computer vision.jpg
// module id = 315
// module chunks = 0